import { MainLayout } from '../Layouts/MainLayout.tsx';
import { Panel } from '../Primitivas/Panel.tsx';
import { MenuItemsUsuario } from '../Menu/MenuItemsUsuario.tsx';

export function Dashboard() {
    return (
        <MainLayout
            titulo={'Dashboard'}
            menuItems={MenuItemsUsuario}
        >
            <Panel titulo={'Ejemplo'}>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </Panel>
        </MainLayout>
    );
}
